// @flow
import { Map, List } from "immutable"

import Watchdog, { WatchdogSearch } from "../records/Watchdog"
import type { BookingInput } from "mmb/records/bookingInput"

// eslint-disable-next-line flowtype/no-weak-types
const translateFn = (translations: Object) => (
  value: string, // eslint-disable-line flowtype/no-weak-types
) => (translations[value] ? translations[value].geo_name : value)

// eslint-disable-next-line flowtype/no-weak-types
const mapPlacesFn = (translate: Function) => (
  places: ?string,
): ?string => // eslint-disable-line flowtype/no-weak-types
  places
    ? places
        .split(",")
        .map(translate)
        .join(", ")
    : null

// eslint-disable-next-line flowtype/no-weak-types
export default function mapperWatchdog(input: Object, translations: Object): Watchdog {
  const searchForms: Array<BookingInput> = input.search_form_json
  const mapPlaces = mapPlacesFn(translateFn(translations))

  const maybeTranslations = new List(
    searchForms.map(
      searchForm =>
        new Map(searchForm)
          .update("flyFrom", mapPlaces) // due to Multiplace
          .update("to", mapPlaces), // due to Multiplace
    ),
  )

  return new Watchdog({
    id: input.id,
    version: input.flights_api_v,
    active: input.active !== 0,
    created: input.created,
    interval: input.interval,
    sortedBy: input.search_form_json[0].sort,
    unsubscribe_hash: input.unsubscribe_hash,
    maybeTranslated: maybeTranslations,
    searches: new List(searchForms.map(searchForm => new WatchdogSearch(searchForm))),
  })
}
